import { render, staticRenderFns } from "./CloudOrders.vue?vue&type=template&id=4e133922&scoped=true"
import script from "./CloudOrders.vue?vue&type=script&lang=js"
export * from "./CloudOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e133922",
  null
  
)

export default component.exports